module.exports = "https://deal-img.imgix.net/consumer/firefox.55e60007.png";